import React, { useEffect, useMemo, useState } from 'react';
import { Card, Bubble, Col, Row } from "tea-component";
import moment from 'moment';

import SvgIcon from '@/pages/home/components/SvgIcon';
import { useLocal, useSelectorMap, useWeekDay } from '@/pages/dashboard/utils/customHook';
import useOverviewLocalesIntl from '@/pages/dashboard/pages/overview/_config/useOverviewLocalesIntl';
import { useIntl } from 'umi';
import { formatNum, handleDate, handleDownload, jumpDetail } from '@/pages/dashboard/utils/utils';
// import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';
import BarChart from '@/pages/dashboard/components/Chart/components/BarChart';
import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { xAxisHighLight } from '@/pages/dashboard/components/Chart/_config/plug';
import { TABLE_CELL_PADDING_LEFT, TABLE_CELL_PADDING_RIGHT } from '@/pages/home/_config/config';

import "@/pages/dashboard/assets/scss/page/Overlay/components/tableCard.scss";
import { getBaseTooltip } from '@/pages/dashboard/components/EchartsTooltip/utils';
import ACard from '@/pages/dashboard/components/ACard';
const PUBLIC_HEIGHT = 290;

// const getSumValue = (arr: any[] = []) => {
//   const sumValue = arr?.reduce((pre, cur) => {
//     if (!isNaN(parseFloat(cur.value))) pre += parseFloat(cur.value);
//     return pre;
//   }, 0);
//   return (sumValue && formatNum(sumValue, false, true)) || '0';
// };


export default function BraekdownContext(props: any) {
  const { data, gameCode, type, componetIndex, formValue } = props;
  const { getSelectorText } = useSelectorMap();
  const { formatMessage } = useIntl(); // 中英切换方法
  const { componentData, loading, error } = data || {};
  const channelsNewUserV2Data = componentData?.channels_of_new_user_v2?.metrics?.filter(item => item.values?.filter(items => items !== '')?.length > 0) || [];
  const channelsNewUserV2Name = channelsNewUserV2Data?.map(items => items?.name) || [];

  const rightIcon = [
    {
      type: 'column',
      icon: "column-chart",
      Bubble: formatMessage({ id: 'common_bar_chart' }),
    },
    {
      type: 'discount',
      icon: "discount-chart",
      Bubble: formatMessage({ id: 'common_line_chart' }),
    },
    {
      type: 'sheet',
      icon: "sheet",
      Bubble: formatMessage({ id: 'common_table' }),
    },
  ];
  const [isLine, setIsLine] = useState(rightIcon[0].type);
  const { locale, getLocalText } = useLocal('overview', '_', gameCode);
  const { BREAKDOWN_METRICS } = useOverviewLocalesIntl();

  // 指标对象
  const metricsObj = BREAKDOWN_METRICS[type];
  //* ********************* 两个卡片相关数据 start **********************************/
  const [legendData, setLegendData] = useState([[], []]);
  const [barxAxisData, setBarxAxisData] = useState([[], []]);
  const [linexAxisData, setLinexAxisData] = useState([[], []]);
  const [barSeries, setBarSeries] = useState([[], []]);
  const [lineSeries, setLineSeries] = useState([[], []]);
  const [tableList, setTableList] = useState([[], []]);
  //* ********************* 两个卡片相关数据 end ************************************/

  // 两个卡片表格配置
  const [tableOption, setTableOption] = useState([[], []]);

  // 卡片是否有数据
  const [isNoData, setIsNoData] = useState([true, true]);
  const { getWeekDayStr, getWeekDay } = useWeekDay();

  const formatterFunc2 = (params, timeType = 'DAY', sumName = 'Total') =>

    getBaseTooltip({
      params,
      options: {
        valueNameCn: sumName,
        valueNameEn: sumName,
        isEn: locale === 'en-US',
        formatFirstThText: timeType !== 'MONTH' ? getWeekDayStr : (date) => moment(date)?.format('YYYY-MM')
      }
    })

    // 'New Users' sort
    // let data = sumName === formatMessage({ id: 'overview_monthly_New_Users' }) ? [...params].sort((f, s) => s.value - f.value) : [...params];
    // data = data.map(({ seriesName, value, color }) => ({
    //   name: seriesName,
    //   metricsNum: formatNum(value, false, true),
    //   color,
    // }));
    // return getEchartTooltipText({
    //   title: getWeekDayStr(moment(`${params[0].axisValue}`).format(timeType === 'MONTH' ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType),
    //   metricsName: '',
    //   hasSum: true,
    //   sumName,
    //   sumNum: getSumValue(params),
    //   data,
    //   isSort: isChannel,
    //   isRemoveNull: isChannel
    // });
    ;

  // 日期格式化
  const dateFormat = (type = 'DAY', value: string, isTable = false): string => {
    if (!value) return '';
    // MONTH维度时，x轴和表格显示为YYYY-MM
    // Day和Week维度时, x轴显示为 MM-DD, 表格显示为YYYY-MM-DD
    const formatStr = type === 'MONTH' ? "YYYY-MM" : (isTable ? "YYYY-MM-DD" : "MM-DD");
    return moment(value).format(formatStr);
  };

  // 下载
  const downloadFun = useMemo(() => (() => {
    if (isNoData[componetIndex]) return;
    const downloadData = tableList[componetIndex]?.map((item: any) => ({
      ...item,
      date: item?.date ? handleDate(item?.date, type) : '-'
    }));
    const tableConfig = {
      option: tableOption[componetIndex],
      downloadData
    };
    handleDownload(tableConfig, metricsObj.BREAKDOWN_AND_NEWUSERS_TITLE[componetIndex]);
  }), [isNoData, tableOption, locale]);

  useEffect(() => {
    if (componentData === null) return;

    setIsNoData([!componentData?.[metricsObj.BREAKDOWN_TOTAL], !componentData?.channels_of_new_user_total]);
    let legendData1: (string | undefined)[] = [];
    if (Object.keys(componentData?.[metricsObj.BREAKDOWN]?.[0] || [])?.length > 0) {
      legendData1 = [
        getLocalText('breakdown_legend1'),
        getLocalText('breakdown_legend2'),
        getLocalText('breakdown_legend3'),
      ];
    }
    // 第二个卡片
    const legendData2 = channelsNewUserV2Name?.map(item => getSelectorText('channel', item));
    setLegendData([legendData1, legendData2]);

    // 卡片柱状图X轴刻度
    // 第一个卡片
    const barxAxisData1 = componentData?.[metricsObj.BREAKDOWN]?.reduce((org, t) => {
      org.push(t?.date);
      return org;
    }, []) || [];
    // 第二个卡片
    const barxAxisData2 = componentData?.channels_of_new_user_v2?.dates || [];
    setBarxAxisData([barxAxisData1, barxAxisData2]);
    setLinexAxisData([barxAxisData1, barxAxisData2]);

    // 柱状图series配置
    // 第一个卡片
    const nameMap = {
      [getLocalText('breakdown_legend1')]: 'new_users',
      [getLocalText('breakdown_legend2')]: 'retention_users',
      [getLocalText('breakdown_legend3')]: 'return_users',
    };
    const barSeries1 = legendData1.reduce((org: any, t) => {
      org.push({
        name: t,
        type: 'bar',
        stack: "Total",
        barMaxWidth: 80,
        barCategoryGap: '50%',
        cursor: 'pointer',
        data: componentData?.[metricsObj.BREAKDOWN].reduce((o, v) => {
          const name = nameMap[t];
          o.push(parseFloat(v[name?.toLowerCase()?.replace(' ', '_')]));
          return o;
        }, []) || null,
      });
      return org;
    }, []) || [];
    // 第二个卡片
    const barSeries2 = channelsNewUserV2Name?.map((name, index) => {
      const metricValue = channelsNewUserV2Data[index] || {};
      const data = metricValue?.name === name ? metricValue.values : [];
      return {
        name: getSelectorText('channel', name),
        type: 'bar',
        stack: "Total",
        barMaxWidth: 80,
        barCategoryGap: '50%',
        cursor: 'pointer',
        data
      };
    });
    setBarSeries([barSeries1, barSeries2]);

    // 折线图series配置
    // 第一个卡片
    const lineSeries1 = legendData1.reduce((org: any, t) => {
      org.push({
        name: t,
        type: 'line',
        // stack: "Total",
        barMaxWidth: 80,
        cursor: 'pointer',
        // areaStyle: {},
        symbolSize: 4,
        showAllSymbol: true,
        symbol: 'circle',
        data: componentData?.[metricsObj.BREAKDOWN].reduce((o, v) => {
          const name = nameMap[t];
          o.push(parseFloat(v[name?.toLowerCase()?.replace(' ', '_')]) || '');
          return o;
        }, []) || null,
      });
      return org;
    }, []) || [];
    // 第二个卡片
    const lineSeries2 = channelsNewUserV2Name?.map((name, index) => {
      const metricValue = channelsNewUserV2Data[index] || {};

      return {
        name: getSelectorText('channel', name),
        type: 'line',
        // stack: "Total",
        barMaxWidth: 80,
        cursor: 'pointer',
        symbolSize: 4,
        showAllSymbol: true,
        symbol: 'circle',
        data: metricValue?.name === name ? metricValue.values : []
      };
    });

    setLineSeries([lineSeries1, lineSeries2]);

    // 表格数据
    // 第一个卡片数据
    const tableList1 = componentData?.[metricsObj.BREAKDOWN]?.reduce((org, t) => {
      org.push(Object.assign({ [metricsObj.AU]: t?.total || 0 }, t));
      return org;
    }, []) || [];
    const { dates = [], total = [] } = componentData?.channels_of_new_user_v2 || {};
    const tableList2 = dates?.map((date, index) => ({
      date,
      'New Users': total[index],
      ...channelsNewUserV2Data.reduce((acc, metric) => {
        acc[getSelectorText('channel', metric?.name)] = metric?.values?.[index];
        return acc;
      }, {}) // 还是会有名称覆盖问题
    })) || [];
    setTableList([tableList1, tableList2]);

    // 表格配置项
    // 第一个卡片表格固定列
    const tableOption1: any = [
      {
        key: "date",
        align: "left",
        fixed: "left",
        width: 120 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_date'),
        render: cvm => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
          return <>
            <span className='table-text'>{dateFormat(type, cvm?.date, true)}</span>
            {type?.toLowerCase() !== 'month' && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
          </>;
        },
      },
      {
        key: metricsObj.AU,
        align: "right",
        fixed: "left",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: metricsObj.AU,
        render: cvm => (<span>{formatNum(cvm[metricsObj.AU], false, true)}</span>),
      },
    ];
    // 第一个卡片表格变化列
    const keyNameMap = {
      new_users: getLocalText('breakdown_legend1'),
      retention_users: getLocalText('breakdown_legend2'),
      return_users: getLocalText('breakdown_legend3'),
    };
    Object.keys(tableList1[0] || []).forEach((t) => {
      if (t === 'date' || t === 'total' || t === metricsObj.AU) return;
      tableOption1.push({
        key: t,
        align: "right",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: keyNameMap[t],
        render: cvm => (<span>{formatNum(cvm[t], false, true)}</span>),
      });
    });
    // 第二个卡片表格固定列
    const tableOption2: any = [
      {
        key: "date",
        align: "left",
        fixed: "left",
        width: 120 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_date'),
        render: cvm => {
          const weekDay = getWeekDay(cvm?.date);
          const isSunOrSat = weekDay === 'Sun' || weekDay === 'Sat' || weekDay === '周日' || weekDay === '周六';
          return <>
            <span className='table-text'>{dateFormat(type, cvm?.date, true)}</span>
            {type?.toLowerCase() !== 'month' && <span className={isSunOrSat ? 'text-week-b' : 'text-week'}>{weekDay}</span>}
          </>;
        },
      },
      {
        key: "New Users",
        align: "right",
        fixed: "left",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getLocalText('table_new_users'),
        render: cvm => (<span>{formatNum(cvm['New Users'], false, true)}</span>),
      },
    ];
    // 第二个卡片表格变化列
    Object.keys(tableList2[0] || []).forEach((t) => {
      if (t === 'date' || t === 'New Users') return;
      tableOption2.push({
        key: t,

        align: "right",
        width: 80 + TABLE_CELL_PADDING_LEFT + TABLE_CELL_PADDING_RIGHT,
        header: getSelectorText('channel', t),
        render: cvm => (<span>{formatNum(cvm[t], false, true)}</span>),
      });
    });
    setTableOption([tableOption1, tableOption2]);
  }, [locale, componentData]);

  const jumptoDetail = () => {
    if (componetIndex === 0) {
      jumpDetail(`/dashboard/game/${props.gameCode}/engagement/active`, formValue);
    } else {
      jumpDetail(`/dashboard/game/${props.gameCode}/engagement/register`, formValue);
    }
  };

  return (
    <Card className='overlay-line'>
      <Card.Body
        title={
          <ACard url={`/dashboard/game/${props.gameCode}/engagement/${componetIndex === 0 ? 'active' : 'register'}`}>
            <div className='overlay-line-title-flex'>
              <div className='dbd-overlay-line-title' onClick={jumptoDetail} >
                <div className='overlay-line-title'>{metricsObj.BREAKDOWN_AND_NEWUSERS_TITLE[componetIndex]}</div>
                <SvgIcon className='overlay-line-title-icon' type='arrow-right'></SvgIcon>
              </div>
            </div>
          </ACard>
        }
        operation={
          !isNoData[componetIndex] &&
          <div className='overlay-line-flex'>
            {
              rightIcon.map(e => <Bubble
                key={e.type}
                dark
                placement="top"
                content={e.Bubble}
              >
                <div className='overlay-line-item' onClick={() => { setIsLine(e.type) }}><SvgIcon className={e.type == isLine ? 'overlay-line-action' : 'overlay-line-icon'} type={e.icon} /></div>
              </Bubble>)
            }
            <Bubble dark placement="top" content=''>
              <i onClick={downloadFun}><SvgIcon className='overlay-line-down' type='download' /></i>
            </Bubble>
          </div>
        }
      >
        <Row>
          {
            (isLine === rightIcon[0].type) ? <Col>
              <div className='dbd-overlay-chart'>
                <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]}
                  style={{ height: PUBLIC_HEIGHT }}
                  component={<BarChart
                    height={PUBLIC_HEIGHT}
                    legendData={legendData[componetIndex]}
                    xAxisData={barxAxisData[componetIndex]}
                    series={barSeries[componetIndex]}
                    formatterFunc={(params) => formatterFunc2(params, type, componetIndex ? formatMessage({ id: 'overview_monthly_New_Users' }) : metricsObj?.AU, componetIndex === 0 ? true : !!componetIndex)}
                    setOtherConfigFunc={(opt) => {
                      opt.xAxis[0].axisLabel.formatter = function (value) {
                        return dateFormat(type, value);
                      };
                      opt = xAxisHighLight(opt, {
                        formatter: (value) => dateFormat(type, value?.value)
                      });
                      return opt;
                    }}
                  />}
                />
              </div>
            </Col> : <></>
          }
          {
            isLine === rightIcon[1].type ? <Col>
              <div className='dbd-overlay-chart'>
                <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]}
                  style={{ height: PUBLIC_HEIGHT }}
                  component={<LineChart
                    height={PUBLIC_HEIGHT}
                    legendData={legendData[componetIndex]}
                    xAxisData={linexAxisData[componetIndex]}
                    series={lineSeries[componetIndex]}
                    formatterFunc={(params) => formatterFunc2(params, type, componetIndex ? formatMessage({ id: 'overview_monthly_New_Users' }) : metricsObj?.AU, !!componetIndex)}
                    setOtherConfigFunc={(opt) => {
                      opt.xAxis[0].axisLabel.formatter = function (value) {
                        return dateFormat(type, value);
                      };
                      opt = xAxisHighLight(opt, {
                        formatter: (value) => dateFormat(type, value?.value)
                      });
                      return opt;
                    }}
                  />}
                />
              </div>
            </Col> : <></>
          }
          {
            isLine == rightIcon[2].type ? <Col>
              <Abnormal isLoading={loading} isError={error} isNoData={isNoData[componetIndex]} style={{ height: PUBLIC_HEIGHT }}
                component={
                  <MiniTable
                    height={PUBLIC_HEIGHT}
                    loading={loading}
                    tableOption={tableOption[componetIndex]}
                    tableList={tableList[componetIndex]}
                    scrolLableVal={{
                      maxHeight: 247,
                      minHeight: 247,
                    }}
                  />
                }
              />
            </Col> : <></>
          }
        </Row>
      </Card.Body>
    </Card>
  );
};
